export default class CarouselError extends Error {
  constructor(msg: string) {
    super(msg);

    Object.setPrototypeOf(this, CarouselError.prototype);
  }

  slideOutOfRange() {
    return "Slide index out of range. Please insert a integer positive value.\n" + this.message;
  }

  intervalOutOfRange() {
    return (
      "Interval is in miliseconds and integer only. Please insert a valid value.\n" + this.message
    );
  }

  currentSlideOutOfRange() {
    return (
      "Current slide index out of range. Please insert a integer positive value.\n" + this.message
    );
  }

  slidesPerPageFormatForResponsiveConfig() {
    return (
      "Format of slidesPerPage is wrong. Please use SlidesPerPageInterface to set your configuration.\n" +
      this.message
    );
  }
}
